<template>
    <el-dialog class="el-dialogs" :append-to-body="true" :title="title" :fullscreen="true" :close-on-click-modal="false"
               :visible.sync="visible">
        <div class="mingTitlr">入库基本信息</div>
        <div class="pageTop">
            <el-form size="small" ref="searchForm" :model="searchForm"
                     :rules="rules"
                     label-width="110px">
                <div class="flex_l_c flex_w">
                    <el-form-item label="入库原因" prop="inWarehouseCause" style="width: 33%">
                        <div>{{ $dictUtils.getDictLabel("in_warehouse_cause", searchForm.inWarehouseCause, '') }}</div>
                    </el-form-item>
                    <el-form-item label="预入库时间：" prop="inWarehouseTime" style="width: 33%">
                        <div>{{ searchForm.inWarehouseTime }}</div>
                    </el-form-item>
                    <el-form-item label="申请人：" prop="applicant" style="width: 33%">
                        <div>{{ searchForm.applicantName }}</div>
                    </el-form-item>
                    <el-form-item v-if="pageName == 'outRecord'" label="申请部门：" prop="departmentName" style="width: 33%">
                        <div>{{ searchForm.departmentName }}</div>
                    </el-form-item>
                    <el-form-item v-if="pageName == 'outRecord'" label="申请时间：" prop="applicantTime" style="width: 33%">
                        <div>{{ searchForm.applicantTime }}</div>
                    </el-form-item>
                </div>
                <el-form-item label="入库描述" prop="inWarehouseDescribe">
                    <div>{{ searchForm.inWarehouseDescribe }}</div>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <div>{{ searchForm.inWarehouseDescribe }}</div>
                </el-form-item>
                <div v-if="pageName == 'outRecord'" class="flex_l_c flex_w">
                    <el-form-item label="审批状态" prop="status" style="width: 33%">
                        <div>{{ $dictUtils.getDictLabel("collection_status", searchForm.status, '') }}</div>
                    </el-form-item>
                    <el-form-item label="审批人" prop="handleByName" style="width: 33%">
                        <div>{{ searchForm.handleByName }}</div>
                    </el-form-item>
                    <el-form-item label="审批时间" prop="handleTime" style="width: 33%">
                        <div>{{ searchForm.handleTime }}</div>
                    </el-form-item>
                </div>
                <el-form-item v-if="pageName == 'outRecord'" label="审批建议" prop="reviewComments">
                    <div>{{ searchForm.reviewComments }}</div>
                </el-form-item>
                <el-form-item label="附件" prop="metadataAttachments">
                    <div class="metadataAttachmentsList">
                        <el-card class="elCard" v-for="item in searchForm.metadataAttachments" :key="item.id">
                            <div class="flex_b_c">
                                <div class="flex_l_c flex_1">
                                    <i class="el-icon-tickets icong"></i>
                                    <el-tooltip class="item" effect="dark" :content="item.fileName"
                                                placement="top-start">
                                        <div class="content omit">{{ item.fileName }}</div>
                                    </el-tooltip>
                                </div>
                                <div></div>
                            </div>
                        </el-card>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div class="mingTitlr">入库藏品</div>
        <div class="b_d" style="height: calc(100% - 60px)">
            <el-row :gutter="4" class="h100 configurationList">
                <el-col :span="showList ? 4 : 1" :class="['p_r h100i', showList ? '' : 'el-col-unfold']">
                    <div :class="['unfoldClassifyBtn', showList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
                         @click="showList = !showList"></div>
                    <el-menu class="h100 metadataTree" :default-active="searchForm.basicDataId" @select="selectMenu">
                        <el-menu-item :index="item.basicDataId" v-for="item in basicDataList" :key="item.basicDataId">
                            <span slot="title">{{ item.basicDataName }}</span>
                        </el-menu-item>
                    </el-menu>
                </el-col>
                <el-col :span="showList ? 20 : 24" :class="['h100', showList ? '' : 'el-col-unfold']">
                    <div class="el-table-container">
                        <el-form size="small" class="query-form" ref="form" :model="searchForm" inline
                                 label-width="100px" @keyup.enter.native="refreshList(1)">
                            <el-form-item prop="keyword" label="关键字：">
                                <el-input v-model.trim="keyword" maxlength="20"
                                          placeholder="请输入关键字(限20字)"
                                          clearable></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" icon="el-icon-search" @click="refreshList(1)" size="small">查询
                                </el-button>
                                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
                            </el-form-item>
                        </el-form>
                        <el-table
                                :data="dataList2"
                                size="small" height="100%"
                                class="table" ref="multipleTable" border
                                @selection-change="selectionChangeHandle" row-key='id'
                        >
                            <el-table-column type="selection" :reserve-selection='true' fixed/>
                            <el-table-column prop="dataCode" label="资源编号" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="dataName" label="资源名称" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="warehouseName" label="库房名称"
                                             show-overflow-tooltip></el-table-column>
                            <el-table-column prop="shelfName" label="所在位置" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="stockStatus" label="状态" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed="right" min-width="100px" label="操作">
                                <template slot-scope="{row}">
                                    <el-button type="text" size="small" @click="detail(row)">详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <pagination :total="total" :page.sync="current" :limit.sync="size"
                                    @pagination="refreshList"/>
                    </div>
                </el-col>
            </el-row>

        </div>
        <div slot="footer" class="text_center">
            <el-button size="small" @click="visible = false">返回</el-button>
            <el-button size="small" v-if="pageName != 'outRecord'" type="primary" @click="itemsChange(0)">上一条</el-button>
            <el-button size="small" v-if="pageName != 'outRecord'" type="primary" @click="itemsChange(1)">下一条</el-button>
            <el-button size="small" v-if="searchForm.status == '1' && pageName == 'toExamine'" type="primary" @click="examineData(0)">通过</el-button>
            <el-button size="small" v-if="searchForm.status == '1' && pageName == 'toExamine'" type="primary" @click="examineData(1)">驳回</el-button>
        </div>
        <resource-add-edit-form ref="resourceAddEditForm"></resource-add-edit-form>
        <set-toexamine ref="setToexamine" @refresh="visible = false"></set-toexamine>
    </el-dialog>
</template>

<script>
import ResourceAddEditForm from "@/views/modules/dyygCollect/library/resourceAddEditForm.vue";
import SetToexamine from "@/views/modules/collection/outbound/setToexamine.vue";

export default {
    name: "detailStore",
    components: {SetToexamine, ResourceAddEditForm},
    data() {
        return {
            title: '入库详情',
            visible: false,
            stepChange: 0,
            searchForm: {
                outWarehouseCause: '',
                preInWarehouseTime: '',
                applicant: '',
                inWarehouseDescribe: '',
                remark: '',
                metadataAttachments: [],
            },
            rules: {
                outWarehouseCause: [
                    {required: true, message: '请选择入库原因', trigger: 'change'}
                ],
            },
            showList: true,
            selectAllData: [],
            basicDataId: '',
            keyword: '',
            basicDataList: [],
            dataList: [],
            dataList2: [],
            dataListSelections: [],
            current: 1,
            size: 20,
            total: 0,
            seleData: {},
            metadataBasicMap: {},
            pageName:'',
        }
    },

    methods: {
        init(row,pageName) {
            this.visible = true
            this.seleData = row
            this.pageName = pageName
            this.getDetail()
        },

        getDetail() {
            this.$axios(this.api.collection.getInWarehouseById + this.seleData.id).then(data => {
                if (data && data.status) {
                    this.searchForm = data.data
                    this.basicDataList = data.data.metadataBasicVOS
                    this.metadataBasicMap = data.data.metadataBasicMap
                    this.selectMenu(this.basicDataList[0].basicDataId)
                }
            })
        },

        getUpDataFile(data) {
            this.searchForm.metadataAttachments = data.map(item => {
                this.$set(item.upDate, 'newId', item.id)
                return item.upDate
            })
        },

        deleteUpData(row) {
            this.$refs.resumeUpload.deleteFile(row.newId)
            this.searchForm.metadataAttachments = this.searchForm.metadataAttachments.filter(item => item.newId != row.newId)
        },


        refreshAssociatedData(data) {
            this.basicDataList = data.basicDataIdList
            this.selectAllData = data.selId
            this.selectMenu(this.basicDataList[0].basicDataId)
        },

        // 选择树节点
        selectMenu(val) {
            this.basicDataId = val
            this.reset()
        },

        // 重置
        reset() {
            this.keyword = ''
            this.refreshList(1)
        },

        // 获取数据列表 current: 1第一页
        refreshList(current, clearList) {
            if (current == 1) {
                this.current = 1
            }
            if (clearList) {
                this.$refs.multipleTable.clearSelection()
            }
            this.dataList = JSON.parse(JSON.stringify(this.metadataBasicMap[this.basicDataId]))
            this.total = this.dataList.length
            if (this.keyword !== '') {
                this.dataList = this.dataList.filter(item => {
                    if (item.dataCode) {
                        return item.dataCode.indexOf(this.keyword) != -1
                    }
                })
            }
            this.dataList2 = this.dataList.splice((this.current - 1) * this.size, this.current * this.size)
            if (this.dataList2.length == 0 && this.current > 1) {
                this.current--
                this.refreshList()
            }
        },

        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val.map(item => {
                return item.id
            })
        },

        //资源详情
        detail(row) {
            this.$refs.resourceAddEditForm.init('view', row.dataId, '', row.metadataData.basicDataId, '', row)
        },

        //提交
        doSubmit() {
            this.$axios(this.api.collection.saveOrUpdate, {
                ...this.searchForm,
                data: this.selectAllData,
            }, 'post').then(data => {
                if (data && data.status) {
                    this.$message.success('提交成功')
                    this.visible = false
                    this.$emit('refresh')
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //0上一条 1下一条
        itemsChange(type){
            this.$emit('itemsChange',type)
        },

        // type 0通过 1驳回
        examineData(status){
            let ids = [this.seleData.id]
            let type = status == 0 ? 'through' : 'reject'
            let url = status == 0 ? this.api.collection.collectioninwarehouseBatchSuccess : this.api.collection.collectioninwarehouseBatchReject
            this.$refs.setToexamine.init(ids,type,url)
        },
    },
}
</script>

<style lang="scss" scoped>
.pageTop {
  width: 70%;
  margin: 0 auto;
}

.magTop {
  margin-top: 20vh;
}

.mingTitlr {
  font-weight: bold;
  margin-left: 20px;
  margin-bottom: 15px;
}

.metadataAttachmentsList {
  height: 250px;
  overflow-y: auto;
}

.elCard {
  &::v-deep .el-card__body {
    padding: 10px !important;
  }

  margin-bottom: 15px;

  .icong {
    font-size: 18px;
    margin-right: 10px;
  }

  .content {
    width: 80%;
  }

  .deeldClose {
    font-size: 18px;
    cursor: pointer;
  }
}
</style>